import{View}from'./View';export class PowerBI extends View{}